import React, {Component, PropTypes} from 'react';
import CSSModules from 'react-css-modules'
import config from '../../config'
import {
  Link,
  LinkIcon,
  PlanScorecardFundIssueAccordionItem,
} from '../../components'
import Styles from './PlanScorecardFundIssueAccordion.css'

@CSSModules(Styles,{allowMultiple:true})
export default class PlanScorecardFundIssueAccordion extends Component {
  static propTypes = {
    fund: PropTypes.object.isRequired
  }
  constructor(props){
    super(props)

    const { fund } = this.props

    this.state = {
      fund,
      resultsConfig: {
        e: [
          {
            id: 'fff',
            site: 'Fossil Free Funds',
            name: 'Fossil fuels',
            grade: 'grade_fossil',
            description: 'Investments in coal, oil, and fossil gas energy and utility companies, and related financial companies'
          },
          {
            id: 'dff',
            site: 'Deforestation Free Funds',
            name: 'Deforestation',
            grade: 'grade_deforestation',
            description: 'Investments in deforestation-risk agricultural commodities, and related financial companies and consumer brands'
          },
        ],
        s: [
          {
            id: 'gef',
            site: 'Gender Equality Funds',
            name: 'Gender equality',
            grade: 'grade_gender_equality',
            description: 'Gender equality group ranking, based on Equileap company data'
          },
          {
            id: 'gff',
            site: 'Gun Free Funds',
            name: 'Civilian firearms',
            grade: 'grade_guns',
            description: 'Investments in civilian firearms manufacturers, and related gun retailers'
          },
          {
            id: 'pff',
            site: 'Prison Free Funds',
            name: 'Prison industrial complex',
            grade: 'grade_prison_industrial_complex',
            description: 'Investments in prisons and borders industry, including private prison operators'
          },
          {
            id: 'wff',
            site: 'Weapon Free Funds',
            name: 'Military weapons',
            grade: 'grade_military',
            description: 'Investments in military arms manufacturers and services companies, including nuclear weapon manufacturers and servicers'
          },
          {
            id: 'tff',
            site: 'Tobacco Free Funds',
            name: 'Tobacco',
            grade: 'grade_tobacco',
            description: 'Investments in tobacco and e-cigarette manufacturers, and tobacco-promoting entertainment companies'
          },
        ]
      }
    }
  }

  //
  render() {
    const { fund, resultsConfig } = this.state

    //
    if (fund.percent_rated_long <= 0.5) {
      return (
        <div styleName='not-rated-panel'>
          <h3 styleName='not-rated-headline'>
            Not rated
          </h3>
          <p>
            Not rated - this fund was not rated because it is less than 40%
            invested in stock holdings.
          </p>
          <p>
            <Link
              to={config.routes.methodology}
              xstrong
              title='Methodology'
            >Read more about our rating methodology<LinkIcon /></Link>
          </p>
        </div>
      )
    }

    //
    return(
      <div>
        <h3 styleName='th'>
          Environment
        </h3>
        {
          resultsConfig.e.map((el, idx) => {
            return (
              <PlanScorecardFundIssueAccordionItem
                key={'accordion-item-e-'+idx}
                fund={fund}
                el={el}
                idx={idx}
              />
            )
          })
        }
        <h3 styleName='th'>
          Social
        </h3>
        {
          resultsConfig.s.map((el, idx) => {
            return (
              <PlanScorecardFundIssueAccordionItem
                key={'accordion-item-s-'+idx}
                fund={fund}
                el={el}
                idx={idx}
              />
            )
          })
        }
      </div>
    )
  }
}